module.exports = __webpack_public_path__ + "assets/img/c41130200a9bd5707b63938783fdfb1a.png";